/*---------------------------------------------------------------------------------------------
 *  Copyright (c) i-Bridge Systems Philippines Inc. All rights reserved.
 *--------------------------------------------------------------------------------------------*/
import { capitalizeWords } from '../../../utilities/capitalizeWords';
import {
  Table,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Box,
} from '@mui/material';
import { CustomTableCell } from '../../index';
import CheckCircleIcon from '@mui/icons-material/CheckCircle';
import { formatISOToPHT } from '../../../utilities/date';

export const FamilyBackground = (props) => {
  return (
    <Box sx={{ mb: 3, padding: '12px' }}>
      <TableContainer
        sx={{
          height: '100%',
          width: '100%',
          overflow: 'auto',
          padding: '12px',
        }}
      >
        <Table sx={{ width: '100%' }}>
          <TableHead>
            <TableRow>
              <CustomTableCell value="Last Name" />
              <CustomTableCell value="First Name" />
              <CustomTableCell value="Middle Name" />
              <CustomTableCell value="Relationship" />
              <CustomTableCell value="Occupation" />
              <CustomTableCell value="Employer" />
              <CustomTableCell value="Telephone No." />
              <CustomTableCell value="Cellphone No." />
              <CustomTableCell value="Date of Birth" />
              <CustomTableCell value="Address" />
              <CustomTableCell value="Emergency" />
              <CustomTableCell value="Reference Person" />
            </TableRow>
          </TableHead>
          {props.empRelations?.map((relation) => (
            <TableRow key={relation._id}>
              <TableCell>{capitalizeWords(relation.lastname)}</TableCell>
              <TableCell>{capitalizeWords(relation.firstname)}</TableCell>
              <TableCell>{capitalizeWords(relation.middlename)}</TableCell>
              <TableCell>{capitalizeWords(relation.relationship)}</TableCell>
              <TableCell>{capitalizeWords(relation.occupation)}</TableCell>
              <TableCell>{capitalizeWords(relation.employer)}</TableCell>
              <TableCell>{relation.telephone}</TableCell>
              <TableCell>{relation.cellphone}</TableCell>
              <TableCell>{formatISOToPHT(relation.dateofbirth)}</TableCell>
              <TableCell>{capitalizeWords(relation.address)}</TableCell>
              <TableCell>
                {relation.emergency ? (
                  <Box
                    sx={{
                      display: 'flex',
                      justifyContent: 'center',
                      alignItems: 'center',
                    }}
                  >
                    <CheckCircleIcon />
                  </Box>
                ) : null}
              </TableCell>

              <TableCell>
                {relation.referenceperson ? (
                  <Box
                    sx={{
                      display: 'flex',
                      justifyContent: 'center',
                      alignItems: 'center',
                    }}
                  >
                    <CheckCircleIcon />
                  </Box>
                ) : null}
              </TableCell>
            </TableRow>
          ))}
        </Table>
      </TableContainer>
    </Box>
  );
};
